import React from 'react'
import Lightingh from '../components/Lightingh'
import Shopbody from '../components/Shopbody'
import Footer from '../components/Footer'

const Lighting = () => {
  return (
    <>
        <Lightingh/>
        <div className='space2'></div>
        <Shopbody/>
        <div className='space'></div>
        <Footer/>
    </>
  )
}

export default Lighting